export default __webpack_public_path__ + "arrow-left-4e945b2c2dfeb262b0c0a6561f5d6ee7.svg";